import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { useActiveRightSidebarState, useLeftSidebarState } from '@atlassian/jira-layout-controller';
import { useLazyGoals } from '@atlassian/jira-portfolio-3-atlas-goals';
import { useCttSpotlight } from '@atlassian/jira-portfolio-3-onboarding/src/controllers/ctt-onboarding';
import {
	Spotlights,
	useCurrentSpotlight,
} from '@atlassian/jira-portfolio-3-onboarding/src/controllers/spotlights';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { connect } from '@atlassian/jira-react-redux';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller';
import mapDispatchToProps from './command';
import mapStateToProps from './query';
import type {
	DispatchProps,
	OwnProps,
	StateProps,
	AdditionalPropsFromRoadmapWrapper,
} from './types';
import View from './view';

const ConnectedRoadmap = connect<
	StateProps,
	DispatchProps,
	OwnProps & AdditionalPropsFromRoadmapWrapper,
	State
>(
	mapStateToProps,
	mapDispatchToProps,
)(View);

const RoadmapWrapper = (props: OwnProps) => {
	/** The vertical scrollbar width. */
	const SCROLLBAR_WIDTH = 18;

	const { software: edition } = useAppEditions();
	const currentRightSidebarState = useActiveRightSidebarState();
	const { isCollapsed: isLeftSideBarCollapsed, width } = useLeftSidebarState();
	const currentRightSidebarWidth =
		currentRightSidebarState && !currentRightSidebarState.isCollapsed
			? currentRightSidebarState.width
			: 0;

	const [{ spotlight: onboardingSpotlight }] = useCurrentSpotlight();
	const [cttOnboardingSpotlight] = useCttSpotlight();

	const spotlightSelection =
		onboardingSpotlight === Spotlights.Inactive ? cttOnboardingSpotlight : onboardingSpotlight;

	const leftSidebarWidth = !isLeftSideBarCollapsed ? width : SCROLLBAR_WIDTH;

	const intl = useIntl();

	const [{ lazyGoalsByARI }] = useLazyGoals();
	const isGoalsLoading = Object.values(lazyGoalsByARI).some((goal) => goal.isLoading);

	return (
		<ConnectedRoadmap
			{...props}
			edition={edition}
			intl={intl}
			isGoalsLoading={isGoalsLoading}
			leftSidebarWidth={leftSidebarWidth}
			rightSidebarWidth={currentRightSidebarWidth}
			spotlight={spotlightSelection}
		/>
	);
};

export default RoadmapWrapper;
